<template>
  <b-container fluid>
    <RpmClassificationDetail :id="$route.params.id" />
  </b-container>
</template>

<script>
import RpmClassificationDetail from '@/components/master/rpm-classification/Detail';

export default {
  name: 'RpmClassificationDetailView',
  components: { RpmClassificationDetail },
};
</script>
